import clsx from 'clsx';

import { TimesheetInfo } from '#/features/timesheet-info';
import {
  PaidBreakExceptionsActions,
  TimesheetAdditionalInfo,
  TimesheetShiftDetails,
  TimesheetTotals,
} from '#/features/timesheet-review';
import { VerifiedTimesheetAlert } from '#/features/verification-status';
import { Card } from '#/shared/components/Card';
import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { selectTimesheetIsVerified, useTimesheetStore } from '#/shared/stores/timesheetStore';

export function TimesheetReviewContainer() {
  const timesheet = useTimesheetStore(state => state.timesheet);
  const timesheetIsVerified = useTimesheetStore(selectTimesheetIsVerified);
  // TODO: PPL-2240-verify-timesheet-action cleanup - Remove this feature flag usage
  const { isEnabled: isVerifyTimesheetEnabled } = useFeatureFlag('PPL-2240-verify-timesheet-action');

  const showVerifiedAlert = isVerifyTimesheetEnabled && timesheetIsVerified;

  if (!timesheet) {
    return null;
  }

  return (
    <Card className="max-tablet-portrait:border-0 max-tablet-portrait:rounded-none max-tablet-portrait:pb-0">
      {showVerifiedAlert && (
        <div className="desktop-small:hidden">
          <VerifiedTimesheetAlert />
        </div>
      )}

      <h2 className="text-24 font-600">Timesheet review</h2>

      <section
        className={clsx('mt-6', showVerifiedAlert && 'grid grid-cols-1 desktop-small:grid-cols-2 desktop-small:gap-16')}
      >
        <div className={clsx(!showVerifiedAlert && 'grid grid-cols-1 tablet-portrait:grid-cols-2')}>
          <TimesheetInfo />
        </div>
        {showVerifiedAlert && (
          <div className="hidden desktop-small:block">
            <VerifiedTimesheetAlert />
          </div>
        )}
      </section>

      <div className="tablet-portrait:hidden pt-16">
        <PaidBreakExceptionsActions />
      </div>

      <div className="grid grid-cols-1 desktop:grid-cols-2 gap-16 pt-24 max-tablet-portrait:pb-0 pb-8">
        <TimesheetShiftDetails />

        <div className="flex flex-col gap-24">
          <TimesheetTotals />
          <TimesheetAdditionalInfo />
        </div>
      </div>
    </Card>
  );
}
